module.exports = __webpack_public_path__ + "media/images/app/homepage/weddings/bridesmaids-36218bd0932ca198e2fcc764c2d177e6.webp";